/* globals confirm, console, module, require, window */
/* jshint esversion:6, globalstrict:true */
'use strict';

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    UnitsListItem = require('./unitsListItem'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.CollectionView.extend({
    attributes: {
        class: 'unitsList',
        name: 'unitsList'
    },
    childView: UnitsListItem,
    childViewContainer: 'div[name=units]',
    childViewEvents: {
        //
        'edit:end': function (options) {this.trigger('edit:end', options);},
        'edit:inProgress': function (options) {this.trigger('edit:inProgress', options);},
        'edit:start': function (options) {this.trigger('edit:start', options);},
        'vacancy:countChanged': function (options) {this.trigger('vacancy:countChanged', options);}
    },
    tagName: 'div',
    template: templates.unitsList,
    initialize: function () {
        this.childViewOptions = {
            programId: this.options.programId,
            hasAdminAccess: this.options.hasAdminAccess
        };
    }
});
